<!--
 *  ┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐
 *  │Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐
 *  └───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘
 *  ┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐
 *  │~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │
 *  ├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤
 *  │ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │
 *  ├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │
 *  │ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  │               │ 4 │ 5 │ 6 │   │
 *  ├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤
 *  │ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │
 *  ├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││
 *  │ Ctrl│    │Alt │         Space         │ Alt│    │    │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│
 *  └─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘
 -->

<!--
 * @FilePath: CesiumImage.vue
 * @Author: chenwei
 * @Date: 2022-06-28 10:08:12
 * @LastEditors: chenwei
 * @LastEditTime: 2022-06-28 11:00:41
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
-->
<template>
  <div class="map" :id="initId">
    <div class="loction center">
      x：{{ longitude_x }}y：{{ longitude_y }}
    </div>
    <div class="time-step">
      <StepV :timeResolutionUnit="timeResolutionUnit" :arrayList="AllCollection" ref="getTimeData"
             :arrayIndex="layerIndex" :showSFM="true"/>
    </div>
    <div class="change-map" @mouseover="showMore=true" @mouseout="showMore=false">
      <div class="map-box" v-show="showMore">
        <p class="p1">{{ $t('cloudComputing.Chooseabasemap') }}</p>
        <hr>
        <div class="b-box centerS">
          <div class="base-site center2" @click="showWhere(i)" :class="i.isAc?'map-ac':'map-d-ac'"
               v-for="i in isEnglish?mapStyles_en:mapStyles" :key="i.index">
            <img :src="i.img" alt="">
            <p>{{ i.name }}</p>
          </div>
        </div>
      </div>
      <div class="parent center">
        <img src="@/assets/image/earth.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
let viewer
const Cesium = window.Cesium
let labelImagerySL, labelImagery, labelImageryGoogle
let animaEntity, markLayer
import StepV from "@/components/Steps"
import Cesium_measure from "@/utils/CesiumMeasure"
import {getImageShowList} from "@/api/product/index"

export default {
  props: {
    productUnit: {
      type: String
    },
    dataQuery: {
      type: Object
    },
    timeResolutionUnit: {
      type: String
    },
    initId: {
      type: String,
      default: 'map'
    },
    timeRange: {
      type: Object
    },
    isplay: {
      type: Boolean
    },
    is2d: {
      type: Boolean
    },
    url: {
      type: String
    },
    collections: {
      type: Array
    },
    legendObj: {
      type: Object
    },
    simpleName: {
      type: String
    },
    coordinates: {
      type: String
    },
    dataSearchLatLng: {
      type: Object
    }
  },
  components: {
    StepV
  },
  data() {
    return {
      mapStyles: [
        {img: require('../../../assets/image/yx.png'), type: 'yx', isAc: true, name: "天地图(影像)", index: 0},
        {img: require('../../../assets/image/sl.png'), type: 'sl', isAc: false, name: "天地图(矢量)", index: 1},
        {img: require('../../../assets/image/yx.png'), type: 'go', isAc: false, name: "谷歌(影像)", index: 2},
      ],
      mapStyles_en: [
        {img: require('../../../assets/image/yx.png'), type: 'yx', isAc: true, name: "Tian Di Tu(image)", index: 0},
        {img: require('../../../assets/image/sl.png'), type: 'sl', isAc: false, name: "Tian Di Tu(vector)", index: 1},
        {img: require('../../../assets/image/yx.png'), type: 'go', isAc: false, name: "Google(image)", index: 2},
      ],
      showMore: false,
      CesiumMeasure: null,
      startTime: '',
      endTime: '',
      nowTime: '',
      showTime: null,
      AllCollection: [],
      layerIndex: 0,
      isFirst: true,
      loading: false,
      initWind: false,
      showWind: false,
      handlerMarker: null,
      tableList: [],
      longitude_x: '',
      longitude_y: '',
      computedObj: {
        max: {},
        min: {},
        ave: '',
        sta: ''
      },
      isEnglish: false
    }
  },
  watch: {
    timeRange: {
      handler(ol, ne) {
        if (ol.start != ne.start || ol.end != ne.end) {
          viewer.entities.remove(animaEntity)
          this.getLIST()
        }
      },
      deep: true
    },
  },
  destroyed() {
  },
  methods: {
    cartesianTolngLatAlt(cartesian) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian)
      const longitude = Cesium.Math.toDegrees(cartographic.longitude)
      const latitude = Cesium.Math.toDegrees(cartographic.latitude)
      this.$emit('searchHistoryData', longitude, latitude)
    },
    /**
     * @description: 初始化mark点
     * @brief:
     * @Author: chenwei
     * @Date: 2022-06-28 11:00:20
     * @param {*}
     * @param {*}
     * @return {*}
     */
    initMark() {
      markLayer = viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(parseFloat(this.dataSearchLatLng.lng), parseFloat(this.dataSearchLatLng.lat), 500),
        billboard: {
          image: require('../../../../src/assets/image/mark.png'),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          scale: 0.5,
        }
      })
    },
    /**
     * @description: 数组钻取查询
     * @brief: 
     * @Author: chenwei
     * @Date: 2022-08-09 14:54:26
     * @return {*}
     */
    drawMarker() {
      this.CesiumMeasure.clearAll()
      this.handlerMarker = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      this.handlerMarker.setInputAction(event => {
        viewer.entities.remove(markLayer);
        // 屏幕坐标转为空间坐标
        let cartesian = viewer.camera.pickEllipsoid(event.position, viewer.scene.globe.ellipsoid);
        if (cartesian == undefined) {
          console.log('没有获取到坐标')
        } else {
          // 空间坐标转世界坐标(弧度)
          let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
          // 弧度转为角度（经纬度）
          let lon = Cesium.Math.toDegrees(cartographic.longitude);  // 经度值
          let lat = Cesium.Math.toDegrees(cartographic.latitude);   // 纬度值
          markLayer = viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(lon, lat, 500),
            billboard: {
              image: require('../../../../src/assets/image/mark.png'),
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              scale: 0.5,
            }
          })
          this.$emit('searchHistoryData', lon, lat)
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
    },
    cancelDraw() {
      this.CesiumMeasure.clearAll()
      if(this.handlerMarker){
        this.handlerMarker.destroy()
      }
    },
    showWhere(val) {

      this.mapStyles.forEach(element => {
        element.isAc = false
      });
      val.isAc = true
      switch (val.type) {
        case 'yx':
          viewer.imageryLayers.remove(labelImagerySL);
          viewer.imageryLayers.remove(labelImageryGoogle);
          viewer.imageryLayers.addImageryProvider(labelImagery);
          break;
        case 'go':
          viewer.imageryLayers.remove(labelImagerySL);
          viewer.imageryLayers.remove(labelImagery);
          viewer.imageryLayers.addImageryProvider(labelImageryGoogle);
          break;
        default:
          viewer.imageryLayers.remove(labelImagery);
          viewer.imageryLayers.remove(labelImageryGoogle);
          viewer.imageryLayers.addImageryProvider(labelImagerySL);
          break;
      }
    },
    ceju(unit) {
      this.CesiumMeasure.ceju(unit)
    },
    cemian() {
      this.CesiumMeasure.cemian()
    },
    getLIST() {
      let that = this
      const startTime = this.timeRange.start + ' 00:00:00'
      const endTime = this.timeRange.end + ' 23:59:59'
      this.layerIndex = 0
      var speedIndex = 0
      var speed = 10
      let param = {
        // hbmwdNight
        productId: this.simpleName,
        startTime: startTime,
        endTime: endTime
      }
      getImageShowList(param).then(res => {
        that.AllCollection = res.data
        let bounds = JSON.parse(that.coordinates)
        animaEntity = viewer.entities.add({
          rectangle: new Cesium.RectangleGraphics({
            coordinates: Cesium.Rectangle.fromDegrees(
                bounds[0],
                bounds[1],
                bounds[2],
                bounds[3],
            ),
            granularity: Cesium.Math.RADIANS_PER_DEGREE * 7,
            shadows: Cesium.ShadowMode.ENABLED,
            material: new Cesium.ImageMaterialProperty({
              image: new Cesium.CallbackProperty(() => {
                console.log(speedIndex);
                if (that.isplay) {
                  return res.data[that.layerIndex].pngUrl
                }
                if (speedIndex % speed !== 0) {
                  speedIndex++
                  return
                }
                speedIndex++
                that.layerIndex++
                if (that.layerIndex === res.data.length - 1 || that.layerIndex > res.data.length - 1) {
                  that.layerIndex = res.data.length - 1
                  that.$emit('stopAnimate')
                  that.layerIndex = 0
                }
                return res.data[that.layerIndex].pngUrl
              }, true),
              transparent: true
            })
          })
        })

        if (that.isFirst) {
          viewer.flyTo(animaEntity)
          that.isFirst = false
        }
      })
    },
    initMap() {
      let that = this
      Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NjJhZTlhZC00ZjE4LTRhYjYtYWI5Zi02MDQ3YjA1OTI5NjAiLCJpZCI6NjEwNTMsImlhdCI6MTYyNTY0ODgwMX0.BfdY8ePnShWrZomg9sv4dz8G5EG28Jva1dVFgmE7En4';
      viewer = new Cesium.Viewer(this.initId, {
        animation: false, //创建动画部件
        shouldAnimate: true,
        orderIndependentTranslucency: false,
        contextOptions: {
          webgl: {alpha: true},
          requestWebgl2: true
        },
        navigation: false,
        enableLighting: true,
      });
      viewer.scene.globe.depthTestAgainstTerrain = false;//关闭深度检测
      //init结束
      //去掉超图supermap
      viewer._cesiumWidget._creditContainer.style.display = "none";
      viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
      viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)

      viewer.scene.globe.enableLighting = true


      viewer.scene.sun.show = false
      viewer.scene.moon.show = false
      viewer.scene.skyBox.show = false

      viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0)

      viewer.imageryLayers.removeAll()
      labelImagery = new Cesium.TiandituImageryProvider({
        mapStyle: Cesium.TiandituMapsStyle.IMG_C, //天地图全球中文注记服务（经纬度投影）
        token: '859e010cf86575ec92544de21ad4472e',
      });
      labelImagerySL = new Cesium.TiandituImageryProvider({
        mapStyle: Cesium.TiandituMapsStyle.VEC_C, //天地图全球中文注记服务（经纬度投影）
        token: '859e010cf86575ec92544de21ad4472e',
      });
      labelImageryGoogle = new Cesium.UrlTemplateImageryProvider({
        // url: "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s,m&gl=CN&x={x}&y={y}&z={z}"
        url: "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&gl=CN&x={x}&y={y}&z={z}"
      });
      // let sl = viewer.imageryLayers.addImageryProvider(labelImagerySL);
      viewer.imageryLayers.addImageryProvider(labelImagery);
      // yx.typename='yx'
      // sl.typename='sl'

      //左上角经纬度
      var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      var scene = viewer.scene
      var ellipsoid = scene.globe.ellipsoid
      handler.setInputAction(function (movement) {
        let click_position = viewer.scene.camera.pickEllipsoid(movement.endPosition, ellipsoid);
        let carto_position = ellipsoid.cartesianToCartographic(click_position);
        that.longitude_x = Cesium.Math.toDegrees(carto_position.longitude);
        that.longitude_y = Cesium.Math.toDegrees(carto_position.latitude);
        that.longitude_x = that.longitude_x.toFixed(6)
        that.longitude_y = that.longitude_y.toFixed(6)
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

      this.CesiumMeasure = new Cesium_measure(viewer)
      this.CesiumMeasure.initCemian()
      this.CesiumMeasure.initCeJu()
      try {
        this.getLIST()
        this.initMark()
      } catch (error) {
        console.log(error);
      }
    },

  },
  created() {

  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
    this.initMap()
  }
}
</script>

<style lang="scss" scoped>

.map {
  width: 100%;
  height: 100%;

  .loction {
    position: absolute;
    left: 12px;
    top: 0px;
    z-index: 100000;
    color: white;
    height: 29px;
    padding: 0 12px;
    background-image: url("../../../assets/image/product-detail-dialog/矩形 3 拷贝.png");
    background-size: 100% 100%;
  }

  .legend-my {
    position: absolute;
    left: 0;
    bottom: 0px;
    padding-left: 12px;
    z-index: 100000;

    .unit {
      color: white;
    }

    .right {
      position: absolute;
      left: 36px;
      bottom: 6px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 160px;

      p {
        font-size: 12px;
        width: 47px;
        display: inline;
        color: white;
      }
    }

    .legend-show {
      width: 24px;
      height: 160px;
    }
  }

}

.change-map {
  position: absolute;
  right: 8px;
  // transform: translate(calc(50% + 200px), -20px);
  z-index: 1000;
  display: flex;
  align-items: flex-end;

  .parent {
    width: 46px;
    height: 46px;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    margin-left: 12px;
  }

  .map-box {
    width: auto;
    height: 130px;
    background: #FFFFFF;
    border-radius: 10px;

    .p1 {
      color: black;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
    }

    hr {
      margin: 4px 0;
      width: 276px;
    }
  }

  .b-box {
    font-size: 12px;
    padding: 0 8px;

    .base-site {
      cursor: pointer;
    }

    img {
      width: 80px;
      height: 60px;
      border-radius: 4px;
    }

    .map-ac {
      img {
        border: 4px solid #3390F8;
      }

      color: #3390F8;
    }

    .map-d-ac {
      img {
        border: 4px solid white;
      }

      color: black;
    }
  }
}
</style>
